<div class="ng-container">
    <div #dropdown></div>

    <div class="ng-credit-price"
         type="button"
         (click)="toggleCreditVariant()">
        <div *ngIf="!isSearchRunning; else searching">
            В кредит: {{ priceByMonth | priceFormat }} x {{ months }} мес
        </div>
    </div>
</div>

<ng-template #searching>
    <img src="/img/icons/hottable/loading.svg" />
</ng-template>